import { Component, OnInit } from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'sym-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
endPoint = environment.api.loginAPI
  constructor(private sanitizer: DomSanitizer,) { }
  isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement => input !== null && input.tagName === 'IFRAME';
  ngOnInit(): void {
  }
  safeImage() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(`https://golfareus.site.dev.letha-local.co.za`);
  }


  ngAfterViewInit() {
    let frame = document.getElementById('shop');
    if (this.isIFrame(frame) && frame.contentWindow) {
      frame.contentWindow.postMessage({domain: location.href}, '*');
    }

  }
}
